export default __webpack_public_path__ + "static/media/carets-arrows.b1b9eed2.svg";